import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories : [],
  createCategory: "",
  isLoading: false, // Add isLoading property to the initial state
};

const adminCategorySlice = createSlice({
  name: "adminCategory",
  initialState,
  reducers: {

    /// using action for get Categoray
    getCategoryRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when login request starts
    },
    getCategorySuccess: (state, action) => {
      state.categories = action.payload;
      state.isLoading = false; // Set isLoading to false after successful login
    },
    getCategoryFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if login fails
    },

    /// using action for create category
    CreateCategoryRequest: (state) => {
      state.isLoadingPerformTask = true; // Set isLoading to true when login request starts
    },
    CreateCategorySuccess: (state, action) => {
      state.createCategory = action.payload;
      state.isLoadingPerformTask = false; // Set isLoading to false after successful login
    },
    CreateCategoryFailure: (state) => {
      state.isLoadingPerformTask = false; // Set isLoading to false if login fails
    },

    /// using action for create category
    getCategoryByIdRequest: (state) => {
      state.isLoadingPerformTask = true; // Set isLoading to true when login request starts
    },
    getCategoryByIdSuccess: (state, action) => {
      state.getByIdCategory = action.payload;
      state.isLoadingPerformTask = false; // Set isLoading to false after successful login
    },
    getCategoryByIdFailure: (state) => {
      state.isLoadingPerformTask = false; // Set isLoading to false if login fails
    },

    /// using action for create category
    categoryUpdateRequest: (state) => {
      state.isLoadingPerformTask = true; // Set isLoading to true when login request starts
    },
    categoryUpdateSuccess: (state, action) => {
      state.updateCategory = action.payload;
      state.isLoadingPerformTask = false; // Set isLoading to false after successful login
    },
    categoryUpdateFailure: (state) => {
      state.isLoadingPerformTask = false; // Set isLoading to false if login fails
    },

    /// using action for create category
    deleteCategoryRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when login request starts
    },
    deleteCategorySuccess: (state, action) => {
      state.deleteCategory = action.payload;
      state.isLoading = false; // Set isLoading to false after successful login
    },
    deleteCategoryFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if login fails
    },








  },
});

export const {
  
  getCategoryRequest,
  getCategorySuccess,
  getCategoryFailure,
  CreateCategoryRequest,
  CreateCategorySuccess,
  CreateCategoryFailure,

      getCategoryByIdRequest,
    getCategoryByIdSuccess,
    getCategoryByIdFailure,
    categoryUpdateRequest,
    categoryUpdateSuccess,
    categoryUpdateFailure,
    deleteCategoryRequest,
    deleteCategorySuccess,
    deleteCategoryFailure,

  
  
} = adminCategorySlice.actions;

export default adminCategorySlice.reducer;
